/** @format */

// GA4 event helpers. gtag is defined globally in public/index.html.

export const trackEvent = (name, params = {}) => {
	if (typeof window !== "undefined" && typeof window.gtag === "function") {
		window.gtag("event", name, params);
	}
};

// Map a Redux cart item to a GA4 ecommerce item.
// Prices in cart state are per-unit CAD; GA4 wants the checkout currency.
export const gaItemFromCartItem = (item, country) => {
	const unitCad = parseFloat(item.optionInfo?.OUR_PRICE) || 0;
	const unit = country === "USA" ? unitCad * 0.75 : unitCad;
	return {
		item_id:
			item.productInfo?.Fabric_Code || item.productInfo?.OCS_Name || "shade",
		item_name:
			item.productInfo?.New_Program || item.productInfo?.Program || "Shade",
		item_variant:
			item.productInfo?.New_Colour || item.productInfo?.SG_Color || undefined,
		price: +unit.toFixed(2),
		quantity: parseInt(item.optionInfo?.quantity, 10) || 1,
		// Designed in See It in Your Room (screens/visualizer)
		item_list_name: item.optionInfo?.visualizer ? "visualizer" : undefined,
	};
};

export const gaCartValue = (cartItems, country) =>
	+cartItems
		.reduce((total, item) => {
			const gaItem = gaItemFromCartItem(item, country);
			return total + gaItem.price * gaItem.quantity;
		}, 0)
		.toFixed(2);
